// extracted by mini-css-extract-plugin
export default {"ButtonDecline":"ButtonDecline_ButtonDecline__zgl8O","declineText":"ButtonDecline_declineText__ppd8W"};